<template>
  <h2 class="font-weight-light primary--text mb-0 mt-3"> {{title}} </h2>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
<style scoped>
h2 {
  font-size: 22px;
}
</style>